import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'next-intl'
import { fetchClient, nullOn404, userApiClient } from '@/setup/api'

export const getRestaurantQueryOptions = (restaurantSlug: string, locale: string) => {
    const init = {
        params: { path: { restaurantSlug } },
        headers: { 'accept-language': locale },
    }

    // An unknown restaurant slug is "no data", not a failure: callers render
    // notFound() or a placeholder.
    return nullOn404(
        userApiClient.queryOptions('get', '/web/restaurants/{restaurantSlug}', init).queryKey,
        (signal) => fetchClient.GET('/web/restaurants/{restaurantSlug}', { ...init, signal })
    )
}

export function useGetRestaurantQuery(restaurantSlug: string) {
    const locale = useLocale()

    return useQuery(getRestaurantQueryOptions(restaurantSlug, locale))
}
